import React from 'react'
import mainData from '../FetchDataLinks'
import UseFetch from '../UseFetch'
import dd from '../FakeData/index.json'
import BlogPostArticle from '../BlockSearch/BlogPostArticle'
import BlogPostArticleSkeleton from '../BlockSearch/BlogPostArticleSkeleton'


function HashSearch({ query }) {
    const { blogs, loading } = UseFetch(`${mainData.hashsearch}${query}`)
    let a = 0;
    return (
        <>
            {blogs.length !== 0 && <h3>Search Results for {query} in Hashtags</h3>}
            <div className="row">
                {!loading && blogs.map((blog) => {
                    return <BlogPostArticle key={`hashSearchBlog${blog.id}`} slug={blog.slug} PostContent={blog.Content} image={blog.Image} PostHead={blog.Headline} PostName={blog.Headline} authorName={dd[0].authorName} date={blog.date} time={blog.Time} />
                })}
                {loading && Array(6).fill().map(() => {
                    a++;
                    return <BlogPostArticleSkeleton key={`BlogPostSkeleton${a}`} />
                })}
            </div>
        </>
    )
}

export default HashSearch
